export const LOCALE_PREFIX = 'components.GroupEntity'

export const DELETE_GROUP = 'DELETE_GROUP'
export const DELETE_GROUP_REQUEST = 'DELETE_GROUP_REQUEST'
export const DELETE_GROUP_FROM_ENTITY_STACK = 'DELETE_GROUP_FROM_ENTITY_STACK'
